enum LinkOpen {
  SAME_WINDOW = '1',
  NEW_WINDOW = '2',
}

export { LinkOpen };
